module.exports = __webpack_public_path__ + "static/media/ru_kindergarten_instruction.0c26ed86.pdf";